




























import { Prop, Component, Vue } from 'vue-property-decorator'
import { Action, namespace } from 'vuex-class'
import TextInput from './BaseTextInput.vue'
import Notification from './BaseNotification.vue'
import Button from './BaseButton.vue'

const user = namespace('user')

@Component({
  components: { TextInput, Button, Notification },
})
export default class LoginForm extends Vue {
  @Prop({ type: Boolean }) loginEmailRequested: boolean
  @Prop() loginErrorMessage: string
  @Prop() email: string
  @Prop() clearLoginForm: Function
  @Prop() setEmail: Function
  @user.Action requestLoginEmail: Function
  @user.Action login: ({ username, magicCode }: { username: string, magicCode: string }) => Promise<string>

  magicCode = ''

  onSubmit () {
    if (this.email !== '') {
      this.requestLoginEmail(this.email.trim())
    }
  }

  requestCode () {
    console.log('requestCode to log in')
    if (this.email !== '') {
      this.requestLoginEmail(this.email.trim())
    }
  }

  async attemptLogin () {
    console.log('attemptLogin')
    const loginState = await this.login({ username: this.email.trim(), magicCode: this.magicCode })
    console.log('loginState', loginState, loginState === 'success')
    if (loginState === 'success') {
      console.log('emitting event')
      this.$emit('loginSuccess')
    }
  }

  handleEmail (username: string) {
    this.setEmail(username)
  }

  emitClose () {
    this.clearLoginForm()
    this.$emit('close')
  }
}
